<div class="nd-main-container">
  <mat-card oneCard class="nd-one-card">

    <mat-card-title style="display: flex; flex-direction: column; margin-bottom: 1rem;">
        <span class="mat-title">Notification document</span>
        <mat-slide-toggle [(ngModel)]="documentEnabled" (change)="updateDocumentEnabled($event.checked)" style="font-size: 16px;">
            Enabled
        </mat-slide-toggle>
    </mat-card-title>

    <mat-card-content *ngIf="!documentEnabled">
        <p style="color: red; font-style: italic;">The notification will not have attached documents.</p>
    </mat-card-content>

    <mat-card-content *ngIf="documentEnabled">

      <!-- Search Box -->
      <div class="nd-search-section">
        <p>Search and select the notification in PIM.web which you want to add the notification document.</p>
        <div class="search-document-box">
            <mat-form-field
                oneSearchField
                oneSearchFieldBorder="squared"
                oneSearchFieldAppearance="outline"
                oneSearchFieldSize="regular"
                class="nd-document-search"
            >
              <mat-icon matPrefix>search</mat-icon>
              <input matInput placeholder="e.g. QN-CPS-2020-001 or Electrolyte Analyzer" [formControl]="searchDocumentControl"/>
              <button *ngIf="searchDocumentControl.value" one-icon-button-flat mat-flat-button matSuffix (click)="searchDocumentControl.setValue('');">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
            <one-select
                    [formControl]="notificationTypeFormControl"
                    [list]="notificationTypeList"
                    [placeholder]="'Notification type'"                           
                    [width]="'100%'"
                    appearance="outlined"
                    size="big"
                    class="unique-horizontal-stepper-countries-list"></one-select>
            <button [disabled]="!searchDocumentControl.value" mat-stroked-button one-secondary-button (click)="onSerach()">
              Search
            </button>
        </div>
      </div>

      <div *ngIf="!isTableShow && files.length === 0">
        <p> or upload a local document (maximum size: 15 MB): </p>
        <!-- <dl-file-upload></dl-file-upload> -->
        <dl-file-upload-single [fileUploadwithCheck]="'single'"></dl-file-upload-single>
      </div>

      <div *ngIf="files.length > 0" class="ddr-reminder-section">
        <h4>Notification PDF</h4>
        <div class="files-list" *ngFor="let file of files; let i = index">
          <div class="single-file">
            <!-- <span class="ribbonGlobal">Global</span> -->
            <div class="info infoLink" (click)="downloadDocument(file.name)">
              <mat-icon class="one-icons" class="fileIcon">{{file?.fileIcon}}</mat-icon>
              <span class="file-info">
                <span class="name">
                  {{ file?.name }}
                  <span class="globalTag">Global</span>
                </span>
                <p class="size">
                  {{ formatBytes(file?.size) }}
                </p>
              </span>
            </div>
            <mat-icon class="one-icons" (click)="deleteFile(i,file)" class="delete-outline">delete_outline</mat-icon>
          </div>
        </div>
      </div>

      <!-- *ngIf="!isDocumentAdded && dataSource.data.length > 0" -->
      <div  class=" ddr-search-result-section" [ngStyle]="{'display':isTableShow ?'block':'none'}">
        <div class="nd-search-table-heading mat-h4 mat-subheading-1" >
          <span>Search results</span>
          <span *ngIf="dataFlag">{{ dataSource.data.length }} results</span>
          <span *ngIf="!dataFlag">0 results</span>
        </div>

        <table mat-table [dataSource]="dataSource"  *ngIf="dataSource.data.length > 0 && dataFlag" class="w-100">
                                              
            <ng-container matColumnDef="documentTitle">
              <th mat-header-cell *matHeaderCellDef> Document title </th>
              <td mat-cell *matCellDef="let element"> {{element.Title}} </td>
            </ng-container>
        
                          
            <!-- Weight Column -->
            <ng-container matColumnDef="docVersion">
              <th mat-header-cell *matHeaderCellDef> Version </th>
              <td mat-cell *matCellDef="let element"> {{element.VersionNumber}} </td>
            </ng-container>
        
            <!-- Symbol Column -->
            <ng-container matColumnDef="docLanguage">
              <th mat-header-cell *matHeaderCellDef> Language </th>
              <td mat-cell *matCellDef="let element"> {{element.Language[0]['IsoCode'] | uppercase}} </td>
            </ng-container>
            
            <ng-container matColumnDef="docDate">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let element"> {{element.ModifyDate| date: 'dd/MM/yyyy'}}</td>
            </ng-container>
            <ng-container matColumnDef="addIcon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element"> 
                  <i class="one-icons">create_document</i>
                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }"
            class="one-element-row"
            (click)="addSearchedDocument(row,true)"></tr>
        </table>

        <table [disabled]="isTableShow" *ngIf="dataSource.data.length == 0" class="no-data-found-table mat-table cdk-table ng-star-inserted w-100">
          
          <tr class="mat-header-row cdk-header-row ng-star-inserted">
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Document title</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Version</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Language</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Date</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle "></th>
          </tr>

          <tr class="error-msg">

            <td class="error-msg-td" colspan="5">

              <mat-icon class="error-msg-icon" svgIcon="no_data_found"></mat-icon>
              
              <span class="error-msg-title">
                <B>Search error</B> 
              </span>

              <p class="error-msg-para">
                There was an error while running your search. Please try again.
              </p>

            </td>

          </tr>   
        </table>

        <table [disabled]="isTableShow" *ngIf="!dataFlag" class="no-data-found-table mat-table cdk-table ng-star-inserted w-100">
          
          <tr class="mat-header-row cdk-header-row ng-star-inserted">
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Document title</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Version</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Language</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Date</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle "></th>
          </tr>

          <tr class="error-msg">

            <td class="error-msg-td" colspan="5">

              <p class="error-msg-para">
                No document found for this search text and document type.
              </p>

            </td>

          </tr>   
        </table>

        <!-- showFirstLastButtons  -->
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" aria-label="Select page of periodic elements"></mat-paginator>
            
      </div>
        
    </mat-card-content>
  </mat-card>
</div>
